import { ApiUrls } from '../../../../../api/api/apiUrls';
import { useGetCachedPaginatedData, useUpdateCachedItem } from '../../../../../api/cachedDataHooks';
import { CompanyRegistrationDto, UserInfoDto } from '../../../../api';
import { EditableUserInfo } from '../../../../utils/interfaces';

export function useFetchCoreData() {
    const { refetch: refetchCompanyRegistrationData, isFetching: isCompanyRegistrationDataFetching } =
        useGetCachedPaginatedData<CompanyRegistrationDto>({
            url: ApiUrls.userApi.registrations(),
            queryKey: 'COMPANY-REGISTRATION',
            enabled: false,
            useCache: true,
        });

    const { data: userInfoData, refetch: refetchUserInfoData } = useGetCachedPaginatedData<UserInfoDto>({
        url: ApiUrls.userApi.userInfo,
        queryKey: 'USER-INFO',
        enabled: false,
        useCache: true,
    });

    const updateUserInfoMutation = useUpdateCachedItem<EditableUserInfo>({
        url: ApiUrls.userApi.updateSalutation(),
        method: 'PUT',
        queryKey: 'USER-INFO',
    });

    const userData = userInfoData as UserInfoDto;
    return {
        refetchCompanyRegistrationData,
        refetchUserInfoData,
        userData,
        updateUserInfoMutation,
        isCompanyRegistrationDataFetching,
    };
}
